// Updated (In progress Moving component) (Version-2, Upr wala code, i.e; of version-1 yet to work on)
import React, { useState, useEffect, memo } from "react";
import {
  Tabs,
  Tab,
  Box,
  Grid,
  Paper,
} from "@material-ui/core";

import BusinessInfoTabPage from "./BusinessInfoTabPage";
import GroupKnowledgeSessionTabPage from "./GroupKnowledgeSessionTabPage";
import ExpertConsultationTabPage from "./ExpertConsultationTabPage";
import MarketOpportunitiesTabPage from "./MarketOpportunitiesTabPage";
import CompliancesTabPage from "./CompliancesTabPage";
import LoanReadinessTabPage from "./LoanReadinessTabPage";

import PersonaDetailMarketConnectTabPage from "./PersonaDetailMarketConnectTabPage";
import PersonaDetailGroupKnowledgeSessionTabPage from "./PersonaDetailGroupKnowledgeSessionTabPage";
import PersonaDetailExpertConsultationTabPage from "./PersonaDetailExpertConsultationTabPage";
import PersonaDetailComplianceTabPage from "./PersonaDetailComplianceTabPage";
import PersonaDetailBusinessLoanReadinessTabPage from "./PersonaDetailBusinessLoanReadinessTabPage";
import DigitalEnablementTab from "./DigitalEnablementTab";
import DigitalEnablementTabPage from "./DigitalEnablementPersonaTab";

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{ height: "100%", overflowY: "auto" }}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

const JpmcThreeSixtyDegreeModalProfilePageTwo = ({
  userData,
  userResourcesCount,
  resourcesDetails,

  // Resource section
  showNewSection,
  tab,
  handleTabChange,
  addResourcesDetails,

  // Persona section
  newTab,
  handleNewTabChange,
  userGroupKnowledgeSesssionPersonaDetails,
  userExptConsultationPersonaDetails,
  userCompliancePersonalDetails,
  userMarketConnectPersonaDetails,
  userLoanReadinessPersonaDetails,
  userDigitalEnablementPersonaDetails,
  handleSubmitPersonaDetails,
  isPersonaLoading,
  isPersonaFormOpen,
  setIsPersonaFormOpen,
  selectedResourceInstanceId,
  handleFormCancel,
  setIsFormOpen,
  isFormOpen,
  uniqueGroupKnowledgeInstanceId,
  uniqueExpertConsultInstanceId,
  uniqueMarketOppInstanceId,
  uniqueComplianceInstanceId,
  uniqueLoandReadinessInstanceId,
  uniqueDigitalEnablementInstanceId,
  handleUpdatePersonaDetail,
  groupKnowledgeAlreadyFilledPersonaInstanceId,
  expertConsiltAlreadyFilledPersonaInstanceId,
  marketConnectAlreadyFilledPersonaInstanceId,
  complianceAlreadyFilledPersonaInstanceId,
  loanReadinessAlreadyFilledPersonaInstanceId,
  digitalEnablementAlreadyFilledPersonaInstanceId,
}) => {

  let personaIndex = 0;

  return (
    <Box
      style={{
        minHeight: "65vh",
        backgroundColor: "#f9f6fb",
        borderRadius: "10px",
        padding: "24px",
      }}
    >
      <Grid item xs={12} style={{ height: "570px" }}>
        <Paper
          elevation={2}
          style={{
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
            padding: "20px",
          }}
        >
          {/* Tabs */}
          <Box
            style={{
              backgroundColor: "#f1e6f4",
              borderBottom: "1px solid #d1b3d4",
            }}
          >
            <Tabs
              value={showNewSection ? tab : newTab}
              onChange={showNewSection ? handleTabChange : handleNewTabChange}
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{
                style: { backgroundColor: "#75287c" },
              }}
            >
              {showNewSection && <Tab label="User Resource Details" />}

              {resourcesDetails?.KnowledgeSessions?.length > 0 && (
                <Tab label="Group Knowledge Session" />
              )}

              {resourcesDetails?.ExpertConsultations?.length > 0 && (
                <Tab label="Expert Consultation" />
              )}

              {resourcesDetails?.MarketOpportunities?.length > 0 && (
                <Tab label="Market Opportunities" />
              )}

              {resourcesDetails?.Compliances?.length > 0 && (
                <Tab label="Compliances" />
              )}

              {resourcesDetails?.LoanReadiness?.length > 0 && (
                <Tab label="Loan Readiness" />
              )}
              {resourcesDetails?.Deigital?.length > 0 && (
                <Tab label="Digital Enablement" />
              )}
            </Tabs>
          </Box>

          <Box style={{ flexGrow: 1, overflowY: "auto" }}>
            {showNewSection && (
              <>
                <TabPanel value={tab} index={0}>
                  <BusinessInfoTabPage userData={userData} userResourcesCount={userResourcesCount} handleTabChange={handleTabChange} />
                </TabPanel>

                {resourcesDetails?.KnowledgeSessions?.length > 0 && (
                  <TabPanel value={tab} index={1}>
                    <GroupKnowledgeSessionTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                )}

                {resourcesDetails?.ExpertConsultations?.length > 0 && (
                  <TabPanel value={tab} index={2}>
                    <ExpertConsultationTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                )}

                {resourcesDetails?.MarketOpportunities?.length > 0 && (
                  <TabPanel value={tab} index={3}>
                    <MarketOpportunitiesTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                )}

                {resourcesDetails?.Compliances?.length > 0 && (
                  <TabPanel value={tab} index={4}>
                    <CompliancesTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                )}

                {resourcesDetails?.LoanReadiness?.length > 0 && (
                  <TabPanel value={tab} index={5}>
                    <LoanReadinessTabPage resourcesDetails={resourcesDetails} addResourcesDetails={addResourcesDetails} />
                  </TabPanel>
                )}
                {resourcesDetails?.Deigital?.length > 0 && (
                  <TabPanel value={tab} index={6}>
                    <DigitalEnablementTab
                      resourcesDetails={resourcesDetails}
                      addResourcesDetails={addResourcesDetails}
                    />
                  </TabPanel>
                )}
              </>
            )}
            {!showNewSection && (
              <>
                {resourcesDetails?.KnowledgeSessions?.length > 0 && (
                  <PersonaDetailGroupKnowledgeSessionTabPage
                    value={newTab}
                    index={personaIndex++}
                    title="Group Knowledge Session Details"
                    userGroupKnowledgeSesssionPersonaDetails={userGroupKnowledgeSesssionPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueGroupKnowledgeInstanceId={uniqueGroupKnowledgeInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    groupKnowledgeAlreadyFilledPersonaInstanceId={groupKnowledgeAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                    isTestimonialScreen={true}  //  using the reusable component, this flag for to not render edit action part on this screen
                  />
                )}
                {resourcesDetails?.ExpertConsultations?.length > 0 && (
                  <PersonaDetailExpertConsultationTabPage
                    value={newTab}
                    index={personaIndex++}
                    title="Expert Consultation Details"
                    userExptConsultationPersonaDetails={userExptConsultationPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueExpertConsultInstanceId={uniqueExpertConsultInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    expertConsiltAlreadyFilledPersonaInstanceId={expertConsiltAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                    isTestimonialScreen={true} 
                  />
                )}
                {resourcesDetails?.MarketOpportunities?.length > 0 && (
                  <PersonaDetailMarketConnectTabPage
                    value={newTab}
                    index={personaIndex++}
                    title="Market Opportunities Details"
                    userMarketConnectPersonaDetails={userMarketConnectPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueMarketOppInstanceId={uniqueMarketOppInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    marketConnectAlreadyFilledPersonaInstanceId={marketConnectAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                    isTestimonialScreen={true} 
                  />
                )}
                {resourcesDetails?.Compliances?.length > 0 && (
                  <PersonaDetailComplianceTabPage
                    value={newTab}
                    index={personaIndex++}
                    title="Compliances Details"
                    userCompliancePersonalDetails={userCompliancePersonalDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueComplianceInstanceId={uniqueComplianceInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    complianceAlreadyFilledPersonaInstanceId={complianceAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                    isTestimonialScreen={true} 
                  />
                )}
                {resourcesDetails?.LoanReadiness?.length > 0 && (
                  <PersonaDetailBusinessLoanReadinessTabPage
                    value={newTab}
                    index={personaIndex++}
                    title="Loan Readiness Details"
                    userLoanReadinessPersonaDetails={userLoanReadinessPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueLoandReadinessInstanceId={uniqueLoandReadinessInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    loanReadinessAlreadyFilledPersonaInstanceId={loanReadinessAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                    isTestimonialScreen={true} 
                  />
                )}
                {resourcesDetails?.Deigital?.length > 0 && (
                  <DigitalEnablementTabPage
                    value={newTab}
                    index={personaIndex++}
                    title="Digital Enablement Details"
                    userDigitalEanblementPersonaDetails={userDigitalEnablementPersonaDetails}
                    handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                    isPersonaLoading={isPersonaLoading}
                    isPersonaFormOpen={isPersonaFormOpen}
                    setIsPersonaFormOpen={setIsPersonaFormOpen}
                    selectedResourceInstanceId={selectedResourceInstanceId}
                    handleFormCancel={handleFormCancel}
                    setIsFormOpen={setIsFormOpen}
                    isFormOpen={isFormOpen}
                    uniqueLoandReadinessInstanceId={uniqueDigitalEnablementInstanceId}
                    handleUpdatePersonaDetail={handleUpdatePersonaDetail}
                    digitalEnablementAlreadyFilledPersonaInstanceId={digitalEnablementAlreadyFilledPersonaInstanceId}
                    resourcesDetails={resourcesDetails}
                    isTestimonialScreen={true}
                  />
                )}
              </>
            )}
          </Box>
        </Paper>
      </Grid>
    </Box>
  );
};

export default memo(JpmcThreeSixtyDegreeModalProfilePageTwo);
 